module.exports = __webpack_public_path__ + "static/img/back-icon02.a37e3af7.png";